<template>
  <section class="user-head">
    <img
      :src="userInfo.icon ? userInfo.icon : '/static/img/mr-usericon.png'"
      alt=""
    />
    <div class="info">
      <h1>{{userInfo.userName}}<img v-if="userInfo.certify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt=""> </h1>
      <div class="info-count">
        <span class="artic-num-icon">文章<b>{{userInfo.articleNum}}</b></span>
        <span class="el-icon-circle-check">关注<b>{{userInfo.attentionNum}}</b></span>
        <!-- <span class="el-icon-star-off">收藏<b>{{userInfo.collectNum}}</b></span> -->
        <div class="add-box">
          <el-button
            type="danger"
            plain
            round
            size="mini"
            :class="[
              {
                'el-icon-check': attentionFlag == 1,
                'el-icon-plus': attentionFlag == 0,
              },
              'fr',
              'follow-btn',
            ]"
            @click="followBtn(userInfo.id)"
          >
            {{ this.attentionFlag == 1 ? "已关注" : "关注" }}</el-button
          >
        </div>
      </div>
      <div class="info-des">
        <p>个性签名：{{ userInfo.intro }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import store from "@/store";
export default {
  name: "UserHeader",
  data() {
    return {
      userInfo: "",
      attentionFlag: "",
    };
  },
  methods: {
    followBtn(id) {
      this.$api
        .attentionHandle({
          userId: id,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.attentionFlag = this.attentionFlag == 1 ? 0 : 1;
        });
    },
    userInfoDetail() {
      this.$api
        .userDetail({
          id: this.$route.params.id,
        })
        .then((res) => {
          this.userInfo = res.data.data
          this.attentionFlag = res.data.data.attentionFlag
        });
    },
  },
  created() {
    this.userInfoDetail()
  }
};
</script>

<style scoped lang="scss">
.user-head {
  width: 1000px;
  margin: 0px auto 10px;
  background: #fff;
  padding: 21px 40px;
  background: url("../assets/images/personal_bg.png") center no-repeat;
  display: flex;
  justify-content: flex-start !important;
  img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    margin-right: 20px;
  }
  .info {
    width: 780px;
    h1 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 10px;
      line-height: 2;
      .dv-rz {
            width: 16px;
            height: 16px;
            margin-left: 5px;
          }
    }
    .info-count {
      font-size: 15px;
      color: #333;
      margin-bottom: 15px;
      position: relative;
      span {
        margin-right: 20px;
        &:before {
          color: #b9b9b9;
          font-size: 17px;
          margin-right: 5px;
        }
        b {
          color: #121212;
          font-size: 18px;
          margin-left: 10px;
        }
      }
      .artic-num-icon {
          padding-left: 22px;
          background: url('../assets/images/activity-num-icon.png') no-repeat left center;
        }
      .active-num-icon {
          padding-left: 22px;
          background: url('../assets/images/artic-num-icon.png') no-repeat left center;
      }
      .add-box {
        right: 0;
        top: -10px;
        position: absolute;
        .follow-btn {
          width: 97px;
          height: 34px;
          background: #317DFF;
          border-radius: 17px;
          color: #fff;
          font-size: 16px;
        }
      }
    }
    .info-des {
      p {
        font-size: 15px;
        line-height: 24px;
        color: #645c5c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OtherUserHead.vue